import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { IInfoEmpresaFactura } from "../entidad/Factura";

export function _SvFacturaObtenerDetalleEmpresa(idEmpresa: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "factura/ObtenerDetalleEmpresa"
    const params = {
        "IdEscuela": idEmpresa,
    }
    return DataDRequest._Request5<IInfoEmpresaFactura>(url, "GET", params)
}